// Entry point for the build script in your package.json

import '@hotwired/turbo-rails'
import './lib/turbo_stream_actions'
import './lib/appsignal'
import './lib/plausible'
import './lib/turbo_error_tracking'
import './controllers'

// CSS Anchor Positioning polyfill - only loaded for browsers without native support
// @see https://github.com/oddbird/css-anchor-positioning
if (!('anchorName' in document.documentElement.style)) {
  import('@oddbird/css-anchor-positioning').then(({ default: polyfill }) => polyfill())
}
